import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

import { WebCommonComponent } from '@seb/web-common/core/web-common.component';

import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    WebCommonComponent
  ]
})
export class AppComponent {
  @HostBinding('attr.app-version') readonly appVersionAttr = environment.appVersion;
}
